import { z } from 'zod';

export const changeRetirementDatePostRequestSchema = z.object({ age: z.string() });
